import { render, staticRenderFns } from "./OrderVps.vue?vue&type=template&id=45077f98&"
import script from "./OrderVps.vue?vue&type=script&lang=js&"
export * from "./OrderVps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports